import React, { Component } from "react";
import ModalPMDecisionsRevenueForecast from "../../../containers/modal/ModalPMDecisionsRevenueForecast";
import NumberFormat from "react-number-format";
import AbbreviateForecastUnit from "../../ui-building-blocks/numbers/AbbreviateForecastUnit";
import PromoSpendTextMasking from "../../promo-spend/PromoSpendTextMasking";
import FontAwesome from "react-fontawesome";
import { deleteRequest } from "../../../api/ApiService";
import {hexToRgba, logError} from "../../../services/utils";
import { decrementUnacceptedDecisions } from "../../../api/SubmitDecisions";
import Styled from "components/pm/style";
import Teams from "api/Teams";
import { view } from "@risingstack/react-easy-state";

class PMDecisionsRevenueForecast extends Component {
  constructor(props) {
    super(props);

    this.state = {
      products: props.products,
      price_forecasts: props.price_forecasts,
      products_prepared: {}
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.products !== nextProps.products ||
      this.state.price_forecasts !== nextProps.price_forecasts
    ) {
      this.setState(
        {
          products: nextProps.products,
          price_forecasts: nextProps.price_forecasts
        },
        () => {
          this.prepareData();
        }
      );
    }
  }

  componentDidMount() {
    this.prepareData();
  }

  prepareData() {
    let products_prepared = {};

    this.state.products.forEach(item => {
      products_prepared[item.id] = {
        name: item.name,
        price: 0,
        forecast: 0,
        revenue_forecast: 0,
        forecast_id: 0,
        player: null
      };
    });

    this.state.price_forecasts.forEach(item => {
      if (item.product in products_prepared) {
        products_prepared[item.product].price = item.price;
        products_prepared[item.product].forecast = item.forecast;
        products_prepared[item.product].revenue_forecast =
          item.revenue_forecast;
        products_prepared[item.product].forecast_id = item.id;
        products_prepared[item.product].player = item.player;
      }
    });

    this.setState({
      products_prepared
    });
  }

  onRemoveForecasts = (e, object_id) => {
    e.preventDefault();

    const { products_prepared } = this.state;
    const products = Object.values(products_prepared);
    const product = products.find(i => i.forecast_id === object_id);

    this.removeForecastsRequest(object_id)
      .then(res => {
        this.props.showSuccessMessage(`Price forecast for product ${product.name} was successfully deleted`);
        decrementUnacceptedDecisions("marketing");
        this.props.reloadData();
        this.props.getSubmissionData();
      })
      .catch(err => {
        logError(err, "PMDecisionsRevenueForecast", "onRemoveForecasts");
      });
  };

  removeForecastsRequest(object_id) {
    return deleteRequest(
      `${process.env.REACT_APP_API_URL}team/price_forecasts/${object_id}/`
    );
  }

  render() {

    return (
      <Styled.WhiteBlockColumn width="407px">
        <div>
          <Styled.RF.Title>Revenue Forecast</Styled.RF.Title>
          <ModalPMDecisionsRevenueForecast
            reloadData={this.props.reloadData}
            products={this.state.products_prepared}
            hasAccess={this.props.hasAccess}
            showRoleAlert={this.props.showRoleAlert}
            countOfProducts={this.props.countOfProducts}
            tourMode={this.props.tourMode}
            getSubmissionData={this.props.getSubmissionData}
            currentRound={this.props.currentRound}
            roundInUrl={this.props.roundInUrl}
            rounds={this.props.rounds}
            showSuccessMessage={this.props.showSuccessMessage}
          />
        </div>
        <Styled.RF.Table rowColor={hexToRgba(Teams.currentTeamColorLevel1(), 0.3)}>
          <table>
            <thead>
              <tr>
                <th>Product</th>
                <th>Price</th>
                <th>Units Forecast</th>
                <th>Expected Revenue</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {Object.keys(this.state.products_prepared).map(product_id => {
                let item = this.state.products_prepared[product_id];
                let can_remove = item.player !== null ? true : false;
                if (this.props.actionsAllowed === false) {
                  can_remove = false;
                }

                return (
                  <tr key={product_id}>
                    <td>{item.name}</td>
                    <td>
                      <NumberFormat
                        value={item.price}
                        displayType="text"
                        prefix="$"
                        thousandSeparator=","
                        decimalSeparator="."
                        decimalPrecision={2}
                      />
                    </td>
                    <td>
                      <AbbreviateForecastUnit value={item.forecast} />
                    </td>
                    <td>
                      <PromoSpendTextMasking value={item.revenue_forecast} />
                    </td>
                    <td>
                      {can_remove === true && (
                        <a
                          href="/#"
                          className="remove-operation"
                          onClick={e =>
                            this.onRemoveForecasts(e, item.forecast_id)
                          }
                        >
                          <FontAwesome name="trash-o" />
                        </a>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Styled.RF.Table>
      </Styled.WhiteBlockColumn>
    );
  }
}

export default view(PMDecisionsRevenueForecast);



// WEBPACK FOOTER //
// ./src/components/pm/decisions/PMDecisionsRevenueForecast.js